import type { AppContext, DeviceContext } from "@storyboard/web-client";

/**
 * Ambient request context the deleted generated Client used to stamp onto content/account events,
 * TTS publishes, heartbeats, and log uploads. DataProvider keeps both current; senders spread them
 * into request bodies at call time.
 */
export const appContext: AppContext = {};
export const deviceContext: DeviceContext = {};
